module.exports = __webpack_public_path__ + "img/ico_news_board_alert.7d9efae2.svg";